/**
 * host模块
 */

// 绝对url
export const absUrl = (url) => {
  const protocolHost = `${window.location.protocol}//${window.location.host}`
  if (/^http(s)?:\/\//gi.test(url)) {
    return url
  }
  return `${protocolHost}${url}`
}

export default absUrl



// WEBPACK FOOTER //
// ./node_modules/@common/host/src/index.js